import * as React from 'react';
import { Fragment } from 'react';
import { Button, ErrorMessage, FlexRow, FormCell, Grid, Header3Text, IconType, RotatingIcon } from 'ui-toolkit/index';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { ITaxCertificationRequestResponse } from '../../../types/order/title/ITaxCertificationRequest';
import {
  eTaxCertificationRequestStatus,
  prettyVendorStatus,
} from '../../../types/order/title/eTaxCertificationRequestStatus';
import { Show } from '../../../components/shared/Show';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

export interface ITaxCertificationRequestProps {
  createTaxCertFetchStatus: IFetchStatus;
  cancelTaxCertFetchStatus: IFetchStatus;
  lastTaxCertificationRequest: ITaxCertificationRequestResponse | undefined;
  cancelTaxCertificationError: Error | undefined;
  createTaxCertificationRequestError: Error | undefined;
  hasTaxCertification: boolean;
  onCreateTaxCertification: () => void;
  onCancelTaxCertification: (taxCertId: string) => void;
}

export const TaxCertificationRequestPage: React.FC<ITaxCertificationRequestProps> = ({
  createTaxCertFetchStatus,
  cancelTaxCertFetchStatus,
  lastTaxCertificationRequest,
  cancelTaxCertificationError,
  createTaxCertificationRequestError,
  hasTaxCertification,
  onCreateTaxCertification,
  onCancelTaxCertification,
}) => {
  const hasActiveTaxCertRequest =
    lastTaxCertificationRequest && lastTaxCertificationRequest.status !== eTaxCertificationRequestStatus.cancelled;

  const etaDate = lastTaxCertificationRequest ? getDateString(DateFormat.long, lastTaxCertificationRequest.eta) : '';
  const createdDate = lastTaxCertificationRequest
    ? getDateString(DateFormat.hugeDateTime, lastTaxCertificationRequest.createdAt, true)
    : '';
  const createdBy = lastTaxCertificationRequest ? lastTaxCertificationRequest.orderedBy : 'Spruce';
  const status = lastTaxCertificationRequest ? lastTaxCertificationRequest.status : null;

  const hintText = (
    <Fragment>
      {etaDate && `ETA: ${etaDate}` && <br />}
      {`By: ${createdBy} on ${createdDate}`}
    </Fragment>
  );

  return (
    <Grid>
      {(createTaxCertFetchStatus.fetching || cancelTaxCertFetchStatus.fetching) && (
        <RotatingIcon type={IconType.Loading} />
      )}
      <ErrorMessage error={cancelTaxCertificationError || createTaxCertificationRequestError} />
      <Header3Text>Tax Certification</Header3Text>
      {hasActiveTaxCertRequest && (
        <>
          <FormCell hintText={hintText}>
            <Header3Text>{prettyVendorStatus[lastTaxCertificationRequest.status]}</Header3Text>
          </FormCell>
          <FlexRow>
            {(status === eTaxCertificationRequestStatus.new ||
              status === eTaxCertificationRequestStatus.inProgress) && (
              <Button
                intent={'primary'}
                onClick={() => onCancelTaxCertification(lastTaxCertificationRequest.taxCertificationRequestId)}
                disabled={cancelTaxCertFetchStatus.fetching}
              >
                Cancel Tax Certification Order
              </Button>
            )}
          </FlexRow>
        </>
      )}
      <Show when={hasTaxCertification}>
        <Button
          intent={'primary'}
          onClick={onCreateTaxCertification}
          disabled={createTaxCertFetchStatus.fetching}
          data-test-id={'orderTaxCertification'}
        >
          Order Updated Tax Certification from KSS
        </Button>
      </Show>
    </Grid>
  );
};
